<div class="p-2 mb-0" [innerHtml]="chatMessage.message"></div>
